import { render, staticRenderFns } from "./AddonProductSkeleton.vue?vue&type=template&id=166b91cc&scoped=true&"
var script = {}
import style0 from "./AddonProductSkeleton.vue?vue&type=style&index=0&id=166b91cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b91cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\occasion-shop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166b91cc')) {
      api.createRecord('166b91cc', component.options)
    } else {
      api.reload('166b91cc', component.options)
    }
    module.hot.accept("./AddonProductSkeleton.vue?vue&type=template&id=166b91cc&scoped=true&", function () {
      api.rerender('166b91cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "OccasionShop/components/Skeletons/AddonProductSkeleton.vue"
export default component.exports